// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../graylog2-server/graylog2-web-interface/node_modules/css-loader/index.js!./MapVisualization.css");
if(typeof content === 'string') content = [[module.id, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = require("!../../../../graylog2-server/graylog2-web-interface/node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../graylog2-server/graylog2-web-interface/node_modules/css-loader/index.js!./MapVisualization.css", function() {
			var newContent = require("!!../../../../graylog2-server/graylog2-web-interface/node_modules/css-loader/index.js!./MapVisualization.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./src/web/components/MapVisualization.css
// module id = 395
// module chunks = 0